import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import LocationAtlas from "../components/LocationAtlas";
import Services from "../components/Services";
import EnergyEstimator from "../components/EnergyEstimator";
import Projects from "../components/Projects";
import SunNeverStops from "../components/SunNeverStops";
import WhySelectra from "../components/WhySelectra";
import Testimonials from "../components/Testimonials";
import FinalCTA from "../components/FinalCTA";
import Contact from "../components/Contact";

export default function Home() {
  return (
    <>
      <Hero />
      <About />
      <LocationAtlas />
      <Services />
      <EnergyEstimator />
      <Projects />
      <SunNeverStops />
      <WhySelectra />
      <Testimonials />
      <FinalCTA />
      <Contact />
    </>
  );
}
